import { Box, Flex } from '@chakra-ui/react';
import {
  ListItemComp,
  ListItemCompContent,
  ListItemCompDescription,
  ListItemCompTitle,
  Cross as CrossIcon,
  Checkbox,
  Icon,
} from '@mesh.ai/rabbit';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';

import { modifyString, StringModifier } from 'constants/copyHelpers';
import { findAndReplaceString } from 'constants/helper';

import { NOTIFICATION_EVENT_CHANNELS } from '../constants/NotificationSettingsConstants';
import { FIXED_COLUMN_WIDTH } from './NotificationEventTable';

export const NotificationEventRow = ({
  moduleType,
  mainEventType,
  heading,
  description,
  notificationEventState,
  onToggle,
  channelDetailsMap,
  isNotControlledByNotificationSettings = false,
  message = '',
  isLastItem,
}) => {
  const { objectivesName, moduleName } = useOrganisationSettings();

  if (!heading) {
    return null;
  }

  const updatedDescription = findAndReplaceString(
    description,
    modifyString(objectivesName, StringModifier.SENTENCE_CASE),
    'objective'
  );

  return (
    <Flex
      minWidth={`calc(300px + ${FIXED_COLUMN_WIDTH * Object.values(channelDetailsMap).length}px)`}
      borderBottom={isLastItem ? 'none' : '1px solid #e2e8f0'}
    >
      <Box flex="1 1 auto" minWidth="300px" padding="8px" overflow="hidden">
        <ListItemComp style={{ padding: 0 }}>
          <ListItemCompContent>
            <ListItemCompTitle bold={false}>{findAndReplaceString(heading, moduleName, 'Goal')}</ListItemCompTitle>
            <ListItemCompDescription>
              {findAndReplaceString(updatedDescription, modifyString(moduleName, StringModifier.SENTENCE_CASE), 'goal')}
            </ListItemCompDescription>
          </ListItemCompContent>
        </ListItemComp>
      </Box>
      {isNotControlledByNotificationSettings ? (
        <Box
          flex={`0 0 ${FIXED_COLUMN_WIDTH * Object.values(channelDetailsMap).length}px`}
          padding="8px"
          textAlign="center"
        >
          <Flex alignItems="center" justifyContent="center" height="100%">
            <span>{message}</span>
          </Flex>
        </Box>
      ) : (
        <>
          {Object.values(channelDetailsMap).map(({ channelType }) => {
            const { type } = NOTIFICATION_EVENT_CHANNELS[channelType] ?? {};
            if (notificationEventState.NOT_SUPPORTED.includes(type)) {
              return (
                <Box flex={`0 0 ${FIXED_COLUMN_WIDTH}px`} padding="8px">
                  <Flex alignItems="center" justifyContent="center" padding="9px" height="100%" color="#999999">
                    <Icon IconSVG={CrossIcon} />
                  </Flex>
                </Box>
              );
            }
            const isDisabled = !channelDetailsMap[type]?.enabled;
            return (
              <Box flex={`0 0 ${FIXED_COLUMN_WIDTH}px`} padding="8px">
                <Flex alignItems="center" justifyContent="center" height="100%">
                  <Checkbox
                    checked={notificationEventState.ENABLED.includes(type)}
                    disabled={isDisabled}
                    onCheckedChange={(checked: boolean) => {
                      onToggle({
                        moduleType,
                        mainEventType,
                        channelType: type,
                        channelState: checked ? 'ENABLED' : 'DISABLED',
                      });
                    }}
                  />
                </Flex>
              </Box>
            );
          })}
        </>
      )}
    </Flex>
  );
};
